import {Injectable} from '@angular/core';
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {erIkkeNil, erNil} from "../støttefunksjoner/nilsjekk";
import {Temporal} from "temporal-polyfill";
import {i18n, Oversettelser} from "felles-ng2/tjenester/i18n/Oversettelser";
import {PlainDateFormat, TemporalFormatering} from "./TemporalFormatering";
import {PlainDatePeriode, PlainDatePeriodeMuligÅpenSlutt} from "felles-ng2/støttefunksjoner/plainDatePerioder";
import PlainDate = Temporal.PlainDate;

const debug = initDebugger('DatoPeriodeUtenTidFormatering');

/**
 * Tjeneste for formatering av {@link PlainDatePeriode}.
 */
@Injectable()
export class DatoPeriodeUtenTidFormatering {

    constructor(private temporalFormatering: TemporalFormatering, private oversettelser: Oversettelser) {
    }

    /**
     * Formaterer angitt periode som '<start> til <slutt>'
     * Bruker 'short' som standard formatering av dato, eks '11.07.2014 til 13.08.2014'
     */
    formater(periode: PlainDatePeriode | null, format: PlainDateFormat = 'short'): string {
       return this.formaterMuligÅpenSlutt(periode, format);
    }

    /**
     * Formaterer angitt periode som '<start> til <slutt>', med støtte for åpen slutt-dato.
     * Bruker 'short' som standard formatering av dato, eks '11.07.2014 til (slutt ikke angitt)'
     */
    formaterMuligÅpenSlutt(periode: PlainDatePeriodeMuligÅpenSlutt | null, format: PlainDateFormat = 'short'): string {
        if (erNil(periode)) return '';

        const datoSomStreng = (dato: PlainDate) => {
            return this.temporalFormatering.formaterPlainDate(dato, format);
        }

        const startSomStreng = datoSomStreng(periode.start);
        let sluttSomStreng = this.oversettelser.oversett(i18n('(slutt ikke angitt)'));
        if (erIkkeNil(periode.slutt)) sluttSomStreng = datoSomStreng(periode.slutt);
        const til = this.oversettelser.oversett(i18n('til'))

        return `${startSomStreng} ${til} ${sluttSomStreng}`;
    }

    //hjelpemetoder

}
